import { Stack, Typography } from '@mui/material'

import { intl } from '@/intl'
import { durationUtils } from '@/server-data'

import { useTexts } from '../useTexts'

interface Props {
  durationSec: number
}

export function Duration(props: Props) {
  const { durationSec } = props
  const formatSeconds = durationUtils.formatSeconds(intl.translate)
  const texts = useTexts()

  return (
    <Stack direction="column" spacing={0}>
      <Typography variant="caption">{texts.duration}</Typography>
      <Typography variant="body1">{formatSeconds(durationSec, 'SHORT')}</Typography>
    </Stack>
  )
}
